import { MagicBox } from "@/components/MagicBox";

export function PageShell({
	header,
	children,
}: { header: React.ReactNode; children: React.ReactNode }) {
	return (
		<MagicBox column grow overflowHidden fullHeight>
			{header}
			<MagicBox p="sm" column overflowHidden grow>
				{children}
			</MagicBox>
		</MagicBox>
	);
}
